import { ImageSource } from 'expo-image'

export type ImageAny = string | ImageSource | null | undefined

export const getAspectRatio = ({
  width,
  height,
}: {
  width: number | null | undefined
  height: number | null | undefined
}) => {
  if (!width) return undefined
  if (!height) return undefined
  return width / height
}
